function toNumber(value) {
  const parsed = Number.parseFloat(value)
  return Number.isNaN(parsed) ? 0 : parsed
}

function roundMoney(value) {
  return Math.round((toNumber(value) + Number.EPSILON) * 100) / 100
}

export function normalizeTicketTaxPercent(value) {
  let percent = toNumber(value)
  if (percent > 1) {
    percent /= 100
  }
  return Math.max(percent, 0)
}

export function ticketUnitPricing(ticket = {}) {
  const price = toNumber(ticket.price ?? ticket.amount)
  const taxPercent = normalizeTicketTaxPercent(ticket.tax_percent)
  const taxEnabled = Boolean(ticket.tax_enabled) && taxPercent > 0 && price > 0
  const priceIncludesTax = Boolean(ticket.tax_price_includes_tax)
  const taxLabel = String(ticket.tax_label || 'IVA').trim() || 'IVA'

  if (!taxEnabled) {
    return {
      baseAmount: roundMoney(price),
      taxAmount: 0,
      grossAmount: roundMoney(price),
      taxPercent,
      taxLabel,
      priceIncludesTax,
    }
  }

  const baseAmount = priceIncludesTax ? price / (1 + taxPercent) : price
  const taxAmount = priceIncludesTax ? price - baseAmount : baseAmount * taxPercent
  const grossAmount = priceIncludesTax ? price : baseAmount + taxAmount

  return {
    baseAmount: roundMoney(baseAmount),
    taxAmount: roundMoney(taxAmount),
    grossAmount: roundMoney(grossAmount),
    taxPercent,
    taxLabel,
    priceIncludesTax,
  }
}
